module.exports = __webpack_public_path__ + "static/media/laddu_back_view.c3a3826b.gif";